import { resolveSelfDisplayName, SelfNameSource } from '../utils/displayName';

/**
 * CORE-764 (заход 7) — the visible name shown in the app header's profile
 * trigger, next to the avatar.
 *
 * History: `dc44ef8cd` (23.05.2026) removed the «name + email» block from the
 * profile dropdown with a comment claiming «the name is already shown next to
 * the avatar in the trigger row». It never was — the trigger row only ever held
 * the avatar and a chevron, so from that commit on the header carried the name
 * purely as an `accessibilityLabel` and showed no visible text. QA (Дмитрий
 * Загумённов, 12.08) filed it as «в шапке имени вообще не стало». This is an old
 * hole, not a regression of the earlier CORE-764 name-source fixes.
 *
 * The whole point of CORE-764 is that the user's name has ONE source. The
 * header always renders the *authenticated* user, so it resolves through the
 * shared {@link resolveSelfDisplayName}: canonical `resolvedDisplayName` from
 * `/auth/me` (master-first, after backend MR !162) wins, personal `displayName`
 * is only the frame-before-auth fallback. This is a thin, header-named entry
 * point over that resolver — deliberately NOT a new fallback chain.
 *
 * Returns `''` when nothing is resolvable yet (e.g. the tick before `/auth/me`
 * lands with no personal name), so the caller can render the avatar alone and
 * fall back to a generic accessible label rather than printing an empty string.
 */
export function resolveHeaderName(user: SelfNameSource | null | undefined): string {
  return resolveSelfDisplayName(user);
}
